module.exports = __webpack_public_path__ + "img/bp_lp_button_contact.8c311674.png";